import {CategoryImageRestDto, CustomerCategoryImageRestDto} from "@/api/pharma-cpc-product-category-mgmt/models";
import {CategoryImageRestDtoModel} from "@/models/api/pharma-cpc-product-category-mgmt/CategoryImageRestDtoModel";

export class CustomerCategoryImageRestDtoModel implements CustomerCategoryImageRestDto {

    image?: CategoryImageRestDto|null;
    image_document_key?: string|null = null;
    is_hidden: boolean = false;
    svg?: string|null = null;

    constructor(image: CategoryImageRestDto) {
        this.image = image;
    }

    public static createWithDefaults(): CustomerCategoryImageRestDtoModel {
        return new this(CategoryImageRestDtoModel.createWithDefaults());
    }
}
